import { BOOKINGAPI } from '../helpers/api'
import { routerParams } from '../helpers/time'
// export function getBuildingList(opts) {
//   return BOOKINGAPI.get(`/desk/building`, { params: opts })
// }
const basicGetFetch = ({ path, delayTime }) => {
  const _delay = delayTime || 360
  return new Promise((reslove, reject) => {
    const res = BOOKINGAPI.get(path)
    setTimeout(() => {
      reslove(res)
    }, _delay)
  })
}

export function loginOut(opts) {
  return BOOKINGAPI.get(`/login/out`)
}
export function getGroupTree(opts) {
  return BOOKINGAPI.get(`/groups/groupTree`, { params: opts })
}

export const querySystemInfo = () => {
  return BOOKINGAPI.get(`/tenant/domain`)
}

//设置页面工位时搜索员工列表
export function getDesksUserList(opts) {
  return BOOKINGAPI.get(`/desk/queryUserList`, { params: opts })
}

export const getDepartTree = (params) => {
  const _path = routerParams('groups/interfacer/tree', params)
  return basicGetFetch({
    path: _path,
  })
}

export function clearAllocate(params) {
  return BOOKINGAPI.patch(`/desk/${params.id || 1}/clear`, params)
}

export function desksAllocate(params) {
  return BOOKINGAPI.patch(`/desk/${params.id || 1}/allocate`, params.dot)
}

export function checkAllocate(params) {
  return BOOKINGAPI.post(`/desk/${params.id || 1}/allocate/check`, params.dot)
}

//弹窗部分获取部门列表
export function getDepartmentList(opts) {
  return BOOKINGAPI.get(`/desk/departments`, { params: opts })
}

// 百度地图数据展示
export function getBaiduMapBuidlings(opts) {
  return BOOKINGAPI.get(`/locations/tree`, { params: opts })
}

// 导出所选楼宇工位分配数据
export function exportBuildingDistributeData(opts) {
  return BOOKINGAPI.get(`/desk/batch/allocate/data`, { params: opts, responseType: 'blob' })
}

// 下载批量分配模板
export function downloadDistributeTemplate(opts) {
  return BOOKINGAPI.get(`/desk/batch/allocate/template`, { params: opts, responseType: 'blob' })
}

// 导入所选楼宇工位分配数据
export function importBuildingDistributeData(opts) {
  return BOOKINGAPI({
    method: 'post',
    url: '/desk/batch/allocate/data',
    data: opts,
  })
}

// 获取角色
export function getCommonPermissionsList(opts) {
  return BOOKINGAPI.get(`/role`, { params: opts })
}

export const getCommonAllBuildings = (params) => {
  return BOOKINGAPI.get(`/building/all`, { params })
}

export function fetchUserListByName(opts) {
  return BOOKINGAPI.get(`/user/searchText`, { params: opts })
}

/**
 * 楼宇地点
 */
export function deleteBuildingApi({ id }) {
  return BOOKINGAPI.delete(`/building/${id}`)
}

export function getBuildingById(params) {
  return BOOKINGAPI.get(`/building/${params.id}`)
}

/** 获取时区列表 **/
export const getTimeZoneList = () => {
  return BOOKINGAPI.get(`/timezone`)
}
/**
 * 根据楼层id 删除楼层
 */
export const deleteBuildingFloorById = (id) => {
  return BOOKINGAPI.delete(`/buildingfloor/${id}`)
}

// 免责申明
export function getUserPrivacy(opts) {
  return BOOKINGAPI.get(`/user/privacy`)
}

export function checkedUserPrivacy(opts) {
  return BOOKINGAPI.post(`/user/privacy`)
}

/**
 * 获取搜索工位列表
 */
export const getDeskListByName = (opts) => {
  return BOOKINGAPI.get(`/desk/searchByName`, { params: opts })
}

/**
 * 获取工位单天预订情况
 */
export const getDeskBookingData = (opts) => {
  return BOOKINGAPI.get(`/desk/reserve/date`, { params: opts })
}
